// Shared workflow stage metadata for the 署名 → 確認 → 承認 approval flow.
import { canVerify, canApprove } from '@/auth/AuthContext';

export const STAGE_ORDER = ['sign', 'check', 'approve'];

// Paper dimensions (mm) per form type — used to convert a square stamp size in
// mm into the editor's %-of-sheet coordinates.
export const FORM_PAPER_MM = {
  overtime: { w: 182, h: 257 },
  leave: { w: 182, h: 128 },
  leave_transfer: { w: 210, h: 297 },
  work_declaration: { w: 210, h: 297 },
  travel_expense: { w: 297, h: 210 },
};
export const formPaperMm = (formType) => FORM_PAPER_MM[formType] || { w: 210, h: 297 };

export const STAGE_ACTION = {
  sign: { label: '署名', verb: '署名する' },
  check: { label: '確認', verb: '確認する' },
  approve: { label: '承認', verb: '承認する' },
};

// status badge meta keyed by submission.stage
export const STAGE_BADGE = {
  awaiting_sign: { label: '署名待ち', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  awaiting_check: { label: '確認待ち', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  awaiting_approve: { label: '承認待ち', cls: 'bg-violet-50 text-violet-700 border-violet-200' },
  approved: { label: '承認済み', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};

export function computeStage(submission, stages = STAGE_ORDER) {
  if (submission?.stage) return submission.stage;
  const done = new Set((submission?.verifications || []).map((v) => v.stage).filter(Boolean));
  for (const s of stages) if (!done.has(s)) return `awaiting_${s}`;
  return 'approved';
}

export function isApplicant(user, submission) {
  if (!user || !submission) return false;
  if (user.role === 'admin') return true;
  const persons = new Set();
  const fd = submission.form_data || {};
  if (Array.isArray(fd.employee_names)) fd.employee_names.forEach((n) => n && persons.add(String(n).trim()));
  [submission.employee_name, fd.employee_name].forEach((v) => {
    if (v) String(v).replace(/、/g, ',').split(',').forEach((p) => p.trim() && persons.add(p.trim()));
  });
  return !!(user.name && persons.has(user.name.trim()));
}

// Which stage can THIS user act on right now (pending stage + eligibility)? or null.
export function eligibleStage(user, submission, stages = STAGE_ORDER) {
  const st = computeStage(submission, stages);
  if (st === 'approved') return null;
  const pending = st.replace('awaiting_', '');
  if (pending === 'sign' && isApplicant(user, submission)) return 'sign';
  if (pending === 'check' && (user?.role === 'admin' || canVerify(user))) return 'check';
  if (pending === 'approve' && (user?.role === 'admin' || canApprove(user))) return 'approve';
  return null;
}
